import { prop, compose, includes, __, not, ifElse, always } from 'ramda';

import { userCountryCode } from 'app/features/user/selectors';
import euCountries from 'app/features/authentication/constants/euCountries';
import { getParsedNextParam } from 'app/router/selectors';
import { LOGIN_PATH, NEXT, REGISTER_PATH } from 'app/router/constants/paths';

const prepareUrlWithNextParam = (path, parsedSearch) =>
  `${path}?${NEXT}=${parsedSearch}`;

const getAuthentication = prop('authentication');
const isAuthenticationLoading = compose(prop('isLoading'), getAuthentication);
const isEuropeCountry = compose(includes(__, euCountries), userCountryCode);
const isEmailOptIn = compose(not, isEuropeCountry);
const registerLink = compose(
  ifElse(
    Boolean,
    next => prepareUrlWithNextParam(REGISTER_PATH, next),
    always(REGISTER_PATH),
  ),
  getParsedNextParam,
);
const loginLink = compose(
  ifElse(
    Boolean,
    next => prepareUrlWithNextParam(LOGIN_PATH, next),
    always(LOGIN_PATH),
  ),
  getParsedNextParam,
);

export { isAuthenticationLoading, isEmailOptIn, registerLink, loginLink };
